/**
 * SearchTokens — the three dresses of the search grammar (board 17, rule cards 2 and 5), used wherever a token
 * appears: the field, the panel, Recent, With these. Pill: yours, applied (filled). Lean: the system's guess,
 * applied (outlined). Offered: not applied (dashed). One definition each, in `SearchTokens.module.scss`.
 */
import {darkSwatch, type FieldToken} from './searchModel'

import styles from './SearchTokens.module.scss'

export function Swatch({hex}: {hex: string}) {
    return <span className={darkSwatch(hex) ? `${styles.swatch} ${styles.swatchDark}` : styles.swatch} style={{background: hex}} aria-hidden="true" />
}

/** A token standing in the field: one click removes it. `marked` is the keyboard's selection (Backspace once). */
export function FieldTokenView({token, marked, onRemove}: {
    token: FieldToken
    marked: boolean
    onRemove: () => void
}) {
    return (
        <button
            type="button"
            className={`${styles.token} ${styles.removable} ${token.kind === 'lean' ? styles.lean : styles.pill}`}
            data-marked={marked ? '' : undefined}
            aria-label={`Remove ${token.label}`}
            onClick={onRemove}
        >
            {token.swatch && <Swatch hex={token.swatch} />}
            {token.label}
        </button>
    )
}

/** A token that only reads: the pills of a Recent row. */
export function StaticPill({label, swatch}: {label: string; swatch?: string}) {
    return (
        <span className={`${styles.token} ${styles.pill} ${styles.still}`}>
            {swatch && <Swatch hex={swatch} />}
            {label}
        </span>
    )
}

/** An offered chip: a tap adds it. `plus` is With these' prefix. */
export function OfferedChip({label, swatch, plus, onClick}: {label: string; swatch?: string; plus?: boolean; onClick: () => void}) {
    return (
        <button type="button" className={`${styles.token} ${styles.offered}`} data-chip="" onClick={onClick}>
            {swatch && <Swatch hex={swatch} />}
            {plus ? `+ ${label}` : label}
        </button>
    )
}

/** The `+N` chip that ends a capped group and opens it in place. */
export function MoreChip({count, onClick}: {count: number; onClick?: () => void}) {
    return (
        <button type="button" className={`${styles.token} ${styles.offered}`} aria-label={`Show ${count} more`} onClick={onClick}>
            +{count}
        </button>
    )
}
